const getIdFromOptions = [
  { value: 'collectionUuid', label: 'Item Id of Collection (Data Group/Table)' },
  { value: 'previousResponse', label: 'Item Id from Previous Step' },
  { value: 'pageCollection', label: 'Item Id of Page Collection' },
];

export const chatGPTActions = [
  {
    name: 'startNewGptConversation',
    label: 'Start New Conversation',
    args: [
      {
        name: 'chatGptId',
        label: 'ChatGPT Prompt',
        type: 'dropdown',
        optionsType: 'dsChatGPT',
        value: '',
      },
      {
        name: 'collectionFields',
        label: 'Fields',
        type: 'dropdown',
        optionsType: 'dsApiCollectionFields',
        multi: true,
        value: '',
      },
      {
        name: 'conversationIdField',
        label: 'Conversation Id Field',
        type: 'dropdown',
        optionsType: 'dsApiCollectionFields',
        value: '',
      },
      {
        name: 'getIdFrom',
        label: 'Get Id From',
        type: 'dropdown',
        options: getIdFromOptions,
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'continueGptConversation',
    label: 'Continue Conversation',
    args: [
      {
        name: 'chatGptId',
        label: 'ChatGPT Prompt',
        type: 'dropdown',
        optionsType: 'dsChatGPT',
        value: '',
      },
      {
        name: 'conversationIdField',
        label: 'Conversation Id Field',
        type: 'dropdown',
        optionsType: 'dsApiCollectionFields',
        value: '',
      },
      {
        name: 'getIdFrom',
        label: 'Get Id From',
        type: 'dropdown',
        options: getIdFromOptions,
        value: '',
      },
      {
        name: 'collectionFields',
        label: 'Fields',
        type: 'dropdown',
        optionsType: 'dsApiCollectionFields',
        multi: true,
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save API Response In Browser Session',
        type: 'boolean',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Session Form Data',
        type: 'boolean',
        value: '',
      },
    ],
  },
];
